export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_ERROR = "USER_LOGIN_ERROR";
export const USER_LOGOUT = "USER_LOGOUT";
export const STAGING_LIST_FILTER = "STAGING_LIST_FILTER";
export const COMPANY_CHECKING = "COMPANY_CHECKING";
